import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { SEED_TESTIMONIALS } from "../lib/siteData";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api
      .get("/site/testimonials")
      .then((r) => {
        if (Array.isArray(r.data) && r.data.length > 0) setItems(r.data);
        else setItems(SEED_TESTIMONIALS);
      })
      .catch(() => setItems(SEED_TESTIMONIALS));
  }, []);

  if (items.length === 0) return null;
  const cur = items[idx % items.length];

  const next = () => setIdx((i) => (i + 1) % items.length);
  const prev = () => setIdx((i) => (i - 1 + items.length) % items.length);

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-20 sm:py-28"
    >
      <div className="container-prose">
        <div className="text-center max-w-3xl mx-auto">
          <p className="overline">11 — Testimonials</p>
          <h2 className="h2-display mt-4 text-3xl sm:text-4xl text-ink">
            What educators say.
          </h2>
        </div>

        <div className="mt-14 max-w-4xl mx-auto text-center relative">
          <span
            aria-hidden
            className="absolute -top-12 -left-2 sm:left-0 text-[120px] sm:text-[180px] leading-none text-forest/15 select-none"
            style={{ fontFamily: '"Cormorant Garamond", serif' }}
          >
            “
          </span>

          <blockquote
            data-testid="testimonial-quote"
            className="relative italic text-ink/90 text-2xl sm:text-3xl leading-snug"
            style={{ fontFamily: '"Cormorant Garamond", serif' }}
          >
            {cur.quote}
          </blockquote>

          <div className="mt-8 text-[13px] uppercase tracking-[0.22em] text-ink/70">
            <span className="font-medium text-ink">{cur.name}</span>
            {(cur.role || cur.organization) && (
              <span className="text-ink/50"> · {[cur.role, cur.organization].filter(Boolean).join(" · ")}</span>
            )}
          </div>

          {items.length > 1 && (
            <div className="mt-10 flex items-center justify-center gap-3">
              <button
                onClick={prev}
                aria-label="Previous testimonial"
                data-testid="testimonial-prev"
                className="h-10 w-10 inline-flex items-center justify-center border border-ink/25 hover:bg-ink hover:text-ivory transition-colors"
              >
                <ChevronLeft size={16} />
              </button>
              <span className="text-[12px] tracking-[0.22em] text-ink/55 uppercase">
                {String(idx + 1).padStart(2, "0")} / {String(items.length).padStart(2, "0")}
              </span>
              <button
                onClick={next}
                aria-label="Next testimonial"
                data-testid="testimonial-next"
                className="h-10 w-10 inline-flex items-center justify-center border border-ink/25 hover:bg-ink hover:text-ivory transition-colors"
              >
                <ChevronRight size={16} />
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
